import createLeadFieldSelect from "./createLeadFieldSelect";

export default createLeadFieldSelect("/leads/all_listing_eff_grade", {
  displayName: "EffectivenessGradeSelect",
  defaultPlaceholder: "Select a Grade...",
});
